export var Variant=/*#__PURE__*/function(a){return a.DESKTOP="desktop",a.MOBILE="mobile",a}({});